import { render, staticRenderFns } from "./SignosVitales.vue?vue&type=template&id=661a42b4&"
import script from "./SignosVitales.vue?vue&type=script&lang=js&"
export * from "./SignosVitales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports